import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import styled from 'styled-components';

import { setIndividualAnswer } from '../utils';
import OTP from 'components/OTP';
import {
  FIELD_CLIENT_TOKEN,
  FIELD_CUSTOMER_ID, FIELD_IS_CUSTOMER_VERIFIED,
  FIELD_PHONE, QUESTION_VERIFICATION,
} from '../constants';
import {BillingAPI} from 'api';
import Lottie from 'components/Lottie';
import successfullyDone from 'assets/successfully-done-lottie.json';
import style from 'style';


const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: center;
  row-gap: 10px;
`;


const VerificationPage = ({ onChange, value, answers, setPagename, progressAction, prevPage }) => {
  const [data, setData] = useState(value ? value : {});
  const phoneNumber = answers.provider[FIELD_PHONE];

  useEffect(() => {
    onChange(data);
  }, [data]);

  useEffect(() => {
    setIndividualAnswer(setData, FIELD_IS_CUSTOMER_VERIFIED, false);
  }, []);

  const handleComplete = (otpCode) => {
    return BillingAPI.getClientTokenWithOTP(otpCode, phoneNumber).then(res => {
      const payload = res.payload;
      setIndividualAnswer(setData, FIELD_CLIENT_TOKEN, payload.client_token);
      setIndividualAnswer(setData, FIELD_CUSTOMER_ID, payload.customer_id);
    });
  };

  const handleSuccess = () => {
    setIndividualAnswer(setData, FIELD_IS_CUSTOMER_VERIFIED, true);
  };

  const handlePhoneNumberClick = () => {
    setPagename(prevPage.name);
    progressAction.decrease();
  };

  return (
    <Container>
      {answers?.[QUESTION_VERIFICATION]?.[FIELD_IS_CUSTOMER_VERIFIED] ? (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
          <Lottie animation={successfullyDone} height="280px" width="280px" options={{loop:true}} />
          <div style={{fontSize: '16px', fontWeight: '400', color: style.colors.palette.textGrey}}>
            Your phone number has been successfully verified. <br/>
            Your account is now secured and ready to continue.
          </div>
        </div>

      ) : (
        <OTP
          phoneNumber={phoneNumber}
          onComplete={handleComplete}
          onSuccess={handleSuccess}
          onPhoneNumberClick={handlePhoneNumberClick}
          hideCancel={true}
        />
      )}
    </Container>
  );
};

VerificationPage.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.string,
  answers: PropTypes.object,
  setPagename: PropTypes.func,
  progressAction: PropTypes.object,
  prevPage: PropTypes.object,
};


export default VerificationPage;
